import { formatSum, TSum } from '../../utils/formatSum'

export type TAmountChangeSource = 'variant' | 'customization'

const SOURCE_LABEL: Record<TAmountChangeSource, string> = {
  variant: 'вариант',
  customization: 'кастомизация',
}

/**
 * CPAYMENT-1669: единая пометка «сумма к переводу отличается от запрошенной».
 *
 * Источник (`variant` — клиент сам выбрал сумму из плитки, `customization` — мэтчинг подогнал
 * сумму под выплату) приходит с бэкенда и осмыслен только вместе с самим фактом изменения.
 * После ручной смены суммы сотрудником бэкенд присылает `null` — бейдж не рисуется, потому что
 * актуальной остаётся сумма сотрудника, а не прежнее «было → стало».
 */
export const AmountChangeBadge = ({
  requestedAmount,
  issuedAmount,
  source,
}: {
  requestedAmount: TSum
  issuedAmount: TSum
  source: TAmountChangeSource | null
}) => {
  if (!source || requestedAmount === null || issuedAmount === null) {
    return null
  }

  // Вторая линия защиты к бэкендовому гейту: суммы совпали — показывать нечего.
  // Спасает и оптимистичное обновление списка после ручной смены суммы сотрудником
  // (там патчатся суммы, а source остаётся из прошлой выдачи списка).
  if (Math.abs(Number(requestedAmount) - Number(issuedAmount)) < 0.01) {
    return null
  }

  return (
    <div className='fs-9 text-muted' title='Сумма к переводу отличается от запрошенной'>
      {formatSum(requestedAmount)}
      <span className='mx-1'>→</span>
      <span className='fw-bold text-dark'>{formatSum(issuedAmount)}</span>
      <span className='ms-1'>· {SOURCE_LABEL[source]}</span>
    </div>
  )
}
